import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
};

const Bookmark2: React.FC<Props> = ({ className, width = '22', height = '22', fill = 'none', stroke = '#0B1215' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 22 22" fill={fill}>
    <path
      d="M17.4168 19.25L11.0002 14.6667L4.5835 19.25V4.58333C4.5835 4.0971 4.77665 3.63079 5.12047 3.28697C5.46428 2.94315 5.9306 2.75 6.41683 2.75H15.5835C16.0697 2.75 16.536 2.94315 16.8799 3.28697C17.2237 3.63079 17.4168 4.0971 17.4168 4.58333V19.25Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Bookmark2;
